module.exports = __webpack_public_path__ + "img/infos-white.6133aecd.svg";